import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "../../style/modal.css";

export default function AgentContectModal({ show, onHide, data }) {
    const [agentData, setAgentData] = useState({});
    useEffect(() => {
        if (data && Object.keys(data).length > 0) setAgentData(data);
    }, [data]);
    return (
        <Modal size="sm" aria-labelledby="contained-modal-title-vcenter" className="modal-details" show={show} centered>
            <Modal.Header className="justify-content-between">
                <Modal.Title>
                    <div className="dlg-cnt text-center">
                        <h5>{agentData?.name ? agentData.name : "Agent"}</h5>
                    </div>
                </Modal.Title>
                <button type="button" onClick={onHide} className="close-icon-style">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                    </svg>
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="dialog-content">
                    <div className="dialog-subtitle justify-content-center">
                        {/* <div className="dlg-img agent_img">
                            <img src={data?.logoPath && data?.logoPath !== "" ? imgBaseUrl + data?.logoPath : emptyAgenacy} className="img-fluid" alt="" />
                        </div> */}
                        {/* <div className="dlg-cnt text-center">
                            <h5>{agentData?.name ? agentData.name : "Agent"}</h5>
                        </div> */}
                    </div>
                    <div className="dialog-text dialog_agency">
                        {agentData?.contacts && (
                            <ul>
                                {agentData?.contacts?.mobileNumber && (
                                    <li>
                                        <span>Mobile</span>
                                        <bdi>
                                            <a href={`tel:+${agentData?.contacts?.mobileNumber}`}>+{agentData?.contacts?.mobileNumber}</a>
                                        </bdi>
                                    </li>
                                )}
                                {agentData?.contacts?.phoneNumber && (
                                    <li>
                                        <span>Phone</span>
                                        <bdi>
                                            <a href={`tel:+${agentData?.contacts?.phoneNumber}`}>+{agentData?.contacts?.phoneNumber}</a>
                                        </bdi>
                                    </li>
                                )}
                                {agentData?.contacts?.proxyPhoneNumber && (
                                    <li>
                                        <span>Proxy Phone</span>
                                        <bdi>
                                            <a href={`tel:+${agentData?.contacts?.proxyPhoneNumber}`}>+{agentData?.contacts?.proxyPhoneNumber}</a>
                                        </bdi>
                                    </li>
                                )}
                                {/* {data?.contacts?.shortNumber && (
                                    <li>
                                        <span>Short No.</span>
                                        <bdi>
                                            <a>{data?.contacts?.shortNumber}</a>
                                        </bdi>
                                    </li>
                                )} */}
                            </ul>
                        )}
                    </div>
                    {/* <div className="dialog-number">
                        <button type="button">
                            <h6>+{data?.contactNumber ? data?.contactNumber : "971 1234 5678 123"}</h6>
                        </button>
                    </div> */}
                </div>
            </Modal.Body>
        </Modal>
    );
}
